import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";

import isEqual from "lodash/isEqual";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { editField } from "../redux";
import { DEFAULT_FEATURES } from "./Remote";
import { useEffect } from "react";

const ThemeSwitcher = ({ theme, setTheme }) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Theme</FormLabel>
      <RadioGroup
        value={theme}
        onChange={(e) => {
          setTheme(e.target.value);
        }}
        row
        aria-label="position"
        name="position"
        defaultValue="top"
      >
        <FormControlLabel
          value="dark_vscode_tribute"
          control={<Radio color="primary" />}
          label="Dark"
        />
        <FormControlLabel
          value="light_mitsuketa_tribute"
          control={<Radio color="primary" />}
          label="Light"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default ({ i }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [theme, setTheme] = useState("dark_vscode_tribute");
  const features = useSelector(({ file: { root } }) => root[i].features);
  const dispatch = useDispatch();
  useEffect(() => {
    setReset(true);
    setTimeout(() => setReset(false));
  }, [theme]);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        style={{
          color: isEqual(DEFAULT_FEATURES, features) ? "red" : "green",
          borderColor: isEqual(DEFAULT_FEATURES, features) ? "red" : "green",
        }}
        onClick={() => setIsOpen(true)}
      >
        Edit Features
      </Button>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Features</DialogTitle>
        <DialogContent>
          <ThemeSwitcher theme={theme} setTheme={setTheme} />
          <JSONInput
            id="test_id"
            placeholder={features}
            locale={locale}
            height="550px"
            theme={theme}
            reset={reset}
            onChange={({ json }) => {
              try {
                const parsedJSON = JSON.parse(json);
                dispatch(editField(`root[${i}].features`, parsedJSON));
              } catch (e) {
                console.warn(`Invalid JSON, not Saving`);
              }
            }}
          />
          <DialogActions>
            <Button onClick={() => setIsOpen(false)} color="secondary">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
